import '@fortawesome/fontawesome-free/css/all.css'
import 'bulma/css/bulma.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
	document.getElementById('root') as HTMLElement,
)
registerServiceWorker()
